<template>
  <v-autocomplete
    outlined
    clearable
    hide-details
    return-object
    hide-selected
    hide-no-data
    no-filter
    unique
    item-text="pessoa.nome"
    label="Transportadora"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs">
      <template v-slot:item="item">
        <slot name="item" v-bind:item="item">
          <v-chip small v-if="showCodigo && item.item.codigoInterno">
            {{ item.item.codigoInterno }}
          </v-chip>
          <span>{{ item.item.pessoa.nome }}</span>
        </slot>
      </template>
      <template v-slot:selection="item">
        <v-chip small v-if="showCodigo && item.item.codigoInterno">
            {{ item.item.codigoInterno }}
        </v-chip>
        <span>{{ item.item.pessoa.nome }}</span>
      </template>
    </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import TransportadoraService from '@/api/transportadora-service';
import { formatCnpj, hasAnyLetter } from '@/utils/regex-utils';

export default {
  props: {
    value: Object,
    path: {
      type: String,
      default: '/fornecedor/all/comprador',
    },
    searchByCode: {
      type: Boolean,
      default: false,
    },
    showCodigo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    value() {
      this.debounceSearch(null);
    },
  },
  methods: {
    buildFilter(val) {
      const text = val || '';
      const cnpjQuery = !hasAnyLetter(text) ? ` or cnpj like "%${formatCnpj(text)}%"` : '';
      const filter = `nome like "%${text.toLowerCase()}%"${cnpjQuery}`;
      return `${filter} order by nome`;
    },
    buildCodigoFilter(val) {
      if (this.searchByCode) {
        return val;
      }
      return undefined;
    },
    searchTransportadoras(val) {
      this.loading = true;

      TransportadoraService.getTransportadorasCompra(this.path, {
        limit: 20,
        query: this.buildFilter(val),
        codigoInterno: this.buildCodigoFilter(val),
      })
        .then(({ data }) => {
          if (this.value) {
            this.items = [this.value, ...data.content];
            return;
          }
          this.items = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchTransportadoras, 1000);
    this.debounceSearch();
  },
};
</script>
